import React from 'react'
import FundraiserMarketing from "../../components/Fundraiser/Marketing";

const Marketing = () => {
  return (
    <FundraiserMarketing />
  )
}

export default Marketing;